export default "__VITE_ASSET__6ab682e3__"